import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";

const Service = () => {
  // Function to toggle service details visibility
  const toggleDetails = (id) => {
    const detailsSection = document.getElementById(`details-${id}`);
    detailsSection.style.display =
      detailsSection.style.display === "block" ? "none" : "block";
  };

  return (
    <Box sx={{ padding: 3, maxWidth: 900, margin: "auto" }}>
      <Typography variant="h4" sx={{ fontWeight: "bold", marginBottom: 3 }}>
        Our Premium Services
      </Typography>

      {/* Service 1 */}
      <Paper sx={{ padding: 2, marginBottom: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Scrom Packages
        </Typography>
        <Typography variant="body2" color="textSecondary">
          We build responsive websites tailored to your business needs.
        </Typography>

        <Button
          variant="outlined"
          sx={{ marginTop: 2 }}
          onClick={() => toggleDetails(1)}
        >
          More Details
        </Button>

        {/* Service Details */}
        <Box
          id="details-1"
          sx={{
            display: "none", // Initially hidden
            marginTop: 2,
            padding: 2,
            borderRadius: "5px",
          }}
        >
          <Typography variant="body2">
            We create fully responsive websites using the latest technologies,
            ensuring optimal user experience and fast load times.
          </Typography>
        </Box>
      </Paper>

      {/* Service 2 */}
      <Paper sx={{ padding: 2, marginBottom: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Salesforces
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Build mobile apps for iOS and Android with modern frameworks.
        </Typography>

        <Button
          variant="outlined"
          sx={{ marginTop: 2 }}
          onClick={() => toggleDetails(2)}
        >
          More Details
        </Button>

        {/* Service Details */}
        <Box
          id="details-2"
          sx={{
            display: "none", // Initially hidden
            marginTop: 2,
            padding: 2,
            borderRadius: "5px",
          }}
        >
          <Typography variant="body2">
            We specialize in creating feature-rich mobile apps for both iOS and
            Android, providing seamless user experiences and performance
            optimization.
          </Typography>
        </Box>
      </Paper>

      {/* Service 3 */}
      <Paper sx={{ padding: 2, marginBottom: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Web Development
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Boost your website's visibility on search engines.
        </Typography>

        <Button
          variant="outlined"
          sx={{ marginTop: 2 }}
          onClick={() => toggleDetails(3)}
        >
          More Details
        </Button>

        {/* Service Details */}
        <Box
          id="details-3"
          sx={{
            display: "none", // Initially hidden
            marginTop: 2,
            padding: 2,
            borderRadius: "5px",
          }}
        >
          <Typography variant="body2">
            We offer SEO services that help your site rank higher on search
            engines, bringing in more organic traffic and improving online
            presence.
          </Typography>
        </Box>
      </Paper>

      {/* Service 4 */}
      <Paper sx={{ padding: 2, marginBottom: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Cloud Hosting
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Secure, scalable hosting for your applications and websites.
        </Typography>

        <Button
          variant="outlined"
          sx={{ marginTop: 2 }}
          onClick={() => toggleDetails(4)}
        >
          More Details
        </Button>

        {/* Service Details */}
        <Box
          id="details-4"
          sx={{
            display: "none", // Initially hidden
            marginTop: 2,
            padding: 2,
            borderRadius: "5px",
          }}
        >
          <Typography variant="body2">
            Our cloud hosting solutions provide high availability, fast scaling,
            and high uptime for your web applications.
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default Service;
